import { EncodeBase64 } from '../../utils/utilityFunctions';
import { CALL_API, getPlatformWisePayload } from '../middleware';
import {
    ChangePasswordPayload,
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    LOGIN,
    LoginPayload,
    LOGIN_OTP_GENERATE_PAYLOAD,
    LOGIN_OTP_VERIFY_PAYLOAD,
    LOGIN_RESEND_OTP,
    LOGIN_SUCCESS,
    LOGOUT,
    LOGOUT_SUCCESS,
    RESEND_LOGIN_OTP,
    RESEND_LOGIN_OTP_SUCCESS,
    SetPasswordPayload,
    SET_PASSWORD,
    SET_PASSWORD_SUCCESS,
    SIGNUP,
    SignupPayload,
    SIGNUP_SUCCESS,
    VerifyOtpPayload,
    VERIFY_OTP,
    VERIFY_OTP_SUCCESS,
    VALIDATE_SECRET_ANSWER,
    VALIDATE_SECRET_ANSWER_SUCCESS,
    SAVE_SECRET_QUESTIONS_SUCCESS,
    SAVE_SECRET_QUESTIONS,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD,
    VERIFY_FORGOT_PASSWORD,
    VERIFY_FORGOT_PASSWORD_SUCCESS,
    NotificationPayload,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS,
    READ_NOTIFICATIONS_SUCCESS,
    READ_NOTIFICATIONS,
    ReadNotificationPayload,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    ForgotPasswordPayload,
    UPDATE_FIRST_TIME_SETTINGS,
    AuthState,
    verifyQuestionnaire,
    ForgotPasswordOtpVerify,
    MOBILE_SESSION_FORCE_LOGOUT,
    FORGOT_QUESTION_ANSWER_OTP_SUCCESS,
    FORGOT_QA,
} from '../types/login';
import { SEND_SMS_OTP, SEND_SMS_OTP_SUCCESS } from '../types/nct';

export const signup = (body: SignupPayload) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/register/verify`,
                method: 'POST',
                types: [SIGNUP_SUCCESS, SIGNUP],
                body,
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const verifyOtp = (body: VerifyOtpPayload) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/otpwrapper/verifyotp`,
                method: 'POST',
                types: [VERIFY_OTP_SUCCESS, VERIFY_OTP],
                body: {
                    ...body,
                    enteredOtp: EncodeBase64(body.enteredOtp),
                },
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const forgotQuestionAnswerOtp = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/user/forgotQuestionAnswerOtp',
                method: 'POST',
                types: [FORGOT_QUESTION_ANSWER_OTP_SUCCESS, FORGOT_QA],
                body: {
                    ...body,
                    action: FORGOT_QA,
                },
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const onSetPassword = (body: SetPasswordPayload) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/register/save`,
                method: 'POST',
                types: [SET_PASSWORD_SUCCESS, SET_PASSWORD],
                body: { ...body, password: EncodeBase64(body.password) },
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const onLogin = (body: LoginPayload) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/register/login`,
                method: 'POST',
                types: [LOGIN_SUCCESS, LOGIN],
                body: { ...body, password: EncodeBase64(body.password) },
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const validateSecretAnswer = (body: verifyQuestionnaire) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/register/validatesecretanswer`,
                method: 'POST',
                types: [VALIDATE_SECRET_ANSWER_SUCCESS, VALIDATE_SECRET_ANSWER],
                body: {
                    ...body,
                    data: [
                        { ...body.data[0], secretAnswer: EncodeBase64(body.data[0].secretAnswer) },
                    ],
                },
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const getOtpForgotPassword =
    (body: { userId: string; action: string }) => async (dispatch: any) => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/register/forgotpassword`,
                    method: 'POST',
                    types: [FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const verifyOtpForgotPassword = (body: ForgotPasswordOtpVerify) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/register/verifyforgotpassword`,
                method: 'POST',
                types: [VERIFY_FORGOT_PASSWORD_SUCCESS, VERIFY_FORGOT_PASSWORD],
                body: {
                    ...body,
                    enteredOtp: EncodeBase64(body.enteredOtp),
                },
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const saveSecretQuestions = (body: LoginPayload) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/register/savesecretanswers`,
                method: 'POST',
                types: [SAVE_SECRET_QUESTIONS_SUCCESS, SAVE_SECRET_QUESTIONS],
                body,
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const onLogout =
    (payload: any, ignoreUnAuthAccess: boolean = false) =>
    async (dispatch: any) => {
        const action = ignoreUnAuthAccess ? MOBILE_SESSION_FORCE_LOGOUT : null;
        const { LOGOUT_ACTION } = getPlatformWisePayload(action);
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/register/logout`,
                    method: 'POST',
                    types: [LOGOUT_ACTION, LOGOUT],
                    body: payload,
                    ignoreUnAuthAccess,
                },
            });
        } catch (error) {
            // alert(error)
        }
    };

// export const onLogout = () => {
//     return {
//         type: LOGOUT,
//         body: null,
//     };
// };

export const onChangePassword = (body: ChangePasswordPayload) => async (dispatch: any) => {
    const _body: ChangePasswordPayload = {
        ...body,
        currentPassword: EncodeBase64(body.currentPassword),
        newPassword: EncodeBase64(body.newPassword),
    };
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/changepassword',
                method: 'POST',
                types: [CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD],
                body: _body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const onResendLoginOTP = (body: LOGIN_RESEND_OTP) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/otpwrapper/resendotp`,
                method: 'POST',
                types: [RESEND_LOGIN_OTP_SUCCESS, RESEND_LOGIN_OTP],
                body,
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const onGenerateLoginOTP = (body: LOGIN_OTP_GENERATE_PAYLOAD) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/register/otplogin`,
                method: 'POST',
                types: [SEND_SMS_OTP_SUCCESS, SEND_SMS_OTP],
                body,
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const onVerifyLoginOTP = (body: LOGIN_OTP_VERIFY_PAYLOAD) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/register/verifyotplogin`,
                method: 'POST',
                types: [LOGIN_SUCCESS, LOGIN],
                body: { ...body, enteredOtp: EncodeBase64(body.enteredOtp) },
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const getNotifications = (body: NotificationPayload) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/notify/getNotification`,
                method: 'POST',
                types: [GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATIONS],
                body,
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const readNotification = (body: ReadNotificationPayload) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/notify/updateNotification`,
                method: 'POST',
                types: [READ_NOTIFICATIONS_SUCCESS, READ_NOTIFICATIONS],
                body,
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const onResetPassword = (body: ForgotPasswordPayload) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/register/updateforgotpassword',
                method: 'POST',
                types: [RESET_PASSWORD_SUCCESS, RESET_PASSWORD],
                body: { ...body, newPassword: EncodeBase64(body.newPassword) },
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const updateFirstTimeSettings = (body: Partial<AuthState>) => {
    return {
        type: UPDATE_FIRST_TIME_SETTINGS,
        body,
    };
};
